import React from 'react';
import { useSelector } from 'react-redux';
import { DeleteOutlined } from '@ant-design/icons';

import {
  CustomNotification,
  dialogFunction,
  ButtonSmallIcon,
} from 'common/components';

import { Menu } from 'antd';

import { useMutationDeleteProductOverlays } from 'common/queries/product-module';

import { useProductOverlaidList } from 'common/queries/product-module';

import { Can, ABILITY_ACTION, ABILITY_SUBJECT } from 'context/Can';

import selectorsGridView from 'common/components/grid-view/controllers/selectors';
import selectorUser from '@redux/user/selectors';

import { useDispatchReloadPage } from 'hooks/useReloadPage';

const DeleteProductOverlay = (props) => {
  const { isProductFullView = false, productFull } = props;

  const itemsSelection = useSelector(
    selectorsGridView.makeSelectDetailCurrentITemsSelection()
  );

  const userInfo = useSelector(selectorUser.makeSelectUserInfo());

  const mutationFn = useMutationDeleteProductOverlays();
  const { invalidateProductOverlaidList } = useProductOverlaidList(null, {
    enabled: false,
  });

  const reloadPage = useDispatchReloadPage();

  const overlayIds = itemsSelection?.map((item) => item?.id);

  const callApiDelete = async () => {
    let params = {};

    if (isProductFullView) {
      params = {
        overlayProductIds: [productFull?.productId],
      };
    } else {
      params = {
        overlayProductIds: overlayIds,
      };
    }

    await mutationFn.mutateAsync(params, {
      onSuccess: (result) => {
        if (result?.isSuccess) {
          CustomNotification.success('Delete successfully');
          reloadPage();
          invalidateProductOverlaidList();
        } else {
          CustomNotification.error(result?.message || 'Cannot delete');
        }
      },
    });
  };

  const confirmDelete = () => {
    const plural = !isProductFullView ? '(s)' : '';

    dialogFunction({
      type: 'warn',
      content: 'Are you sure to delete the selected overlay' + plural + '?',
      onOk: callApiDelete,
    });
  };

  const someIsNotProductOverlay =
    itemsSelection?.length > 0 &&
    itemsSelection.some((productItem) => !productItem.isOverlayProduct);

  const isDisabled = (allowed) => {
    if (!allowed) return true;

    const isOpenBySourceMember =
      productFull?.sourceMemberId === userInfo?.companyId;

    if (isProductFullView) {
      if (!productFull?.isOverlayProduct) return true;

      if (!isOpenBySourceMember) return true;

      return false;
    }

    if (!isProductFullView) {
      if (itemsSelection.length === 0) return true;

      if (someIsNotProductOverlay) return true;

      const isSomeProductOverlayNotCreatedByUserCompany =
        checkSomeProductNotCreatedByUserCompany();

      if (isSomeProductOverlayNotCreatedByUserCompany) return true;

      return false;
    }

    return false;
  };

  const checkSomeProductNotCreatedByUserCompany = () =>
    itemsSelection.some(
      (productItem) => productItem?.sourceMemberId !== userInfo?.companyId
    );

  return (
    <Can
      I={ABILITY_ACTION.DELETE}
      a={ABILITY_SUBJECT.PRODUCT_OVERLAY}
      passThrough
    >
      {(allowed) => {
        const disabled = isDisabled(allowed);

        return (
          <Menu.Item style={{ backgroundColor: 'inherit' }} disabled={disabled}>
            <ButtonSmallIcon
              className='button-item-dropdown'
              icon={<DeleteOutlined />}
              label={'Delete Product Overlay'}
              onClick={confirmDelete}
              disabled={disabled}
            />
          </Menu.Item>
        );
      }}
    </Can>
  );
};

export default DeleteProductOverlay;
